import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import Paper from '@material-ui/core/Paper';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import { OrderListProduct } from 'features/OrdersList/ordersListForm';

const ProductTable: FC<{ product: OrderListProduct }> = ({ product }) => {
  const { t } = useTranslation();
  return (
    <TableContainer component={Paper} elevation={3}>
      <Table stickyHeader aria-label="product">
        <TableHead>
          <TableRow>
            <TableCell align="center">{t('label.name')}</TableCell>
            <TableCell align="center">{t('label.description')}</TableCell>
            <TableCell align="center">{t('label.quantity')}</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          <TableRow>
            <TableCell align="center">
              <span>{product.name}</span>
            </TableCell>
            <TableCell align="center">
              <span>{product.description}</span>
            </TableCell>
            <TableCell align="center">
              <span>{product.serial_number.length}</span>
            </TableCell>
          </TableRow>
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export { ProductTable };
